import React from 'react';

import { stringCmp } from '~/Utils';

import styles from './Users.module.scss';

export type PhoneProfileUser = {
  phone_profile_name?: string | null;
};

export const phoneProfileSpecialCell = (user: PhoneProfileUser): React.ReactNode =>
  user.phone_profile_name ? user.phone_profile_name : <span className={styles.defaultProfileText}>Default</span>;

export const phoneProfileCmp = (a: PhoneProfileUser, b: PhoneProfileUser): number => {
  const an = a.phone_profile_name;
  const bn = b.phone_profile_name;
  if (!an && !bn) return 0;
  if (!an) return 1;
  if (!bn) return -1;
  return stringCmp(an, bn);
};

export const phoneProfileCsvValue = (user: PhoneProfileUser): string => user.phone_profile_name ?? 'Default';
